import *  as service from '../services/PianoTechCompanyServices';

export const FETCH_PIANOTECHCOMPANY_LIST_STARTED = 'FETCH_PIANOTECHCOMPANY_LIST_STARTED';
export const FETCH_PIANOTECHCOMPANY_LIST_SUCCEEDED = 'FETCH_PIANOTECHCOMPANY_LIST_SUCCEEDED';
export const FETCH_PIANOTECHCOMPANY_LIST_FAILED = 'FETCH_PIANOTECHCOMPANY_LIST_FAILED';
export const FIND_PIANOTECHCOMPANY_STARTED = 'FIND_PIANOTECHCOMPANY_STARTED';
export const FIND_PIANOTECHCOMPANY_SUCCEEDED = 'FIND_PIANOTECHCOMPANY_SUCCEEDED';
export const FIND_PIANOTECHCOMPANY_FAILED = 'FIND_PIANOTECHCOMPANY_FAILED';
export const SAVE_PIANOTECHCOMPANY_STARTED = 'SAVE_PIANOTECHCOMPANY_STARTED';
export const SAVE_PIANOTECHCOMPANY_SUCCEEDED = 'SAVE_PIANOTECHCOMPANY_SUCCEEDED';
export const SAVE_PIANOTECHCOMPANY_FAILED = 'SAVE_PIANOTECHCOMPANY_FAILED';
export const RETURN_TO_PIANOTECHCOMPANY_LIST = 'RETURN_TO_PIANOTECHCOMPANY_LIST';
export const SWITCH_EDIT_TYPE_PIANOTECHCOMPANY = 'SWITCH_EDIT_TYPE_PIANOTECHCOMPANY';
export const PIANOTECHCOMPANY_MODIFIED = 'PIANOTECHCOMPANY_MODIFIED';
export const PIANOTECHCOMPANY_VALIDATE = 'PIANOTECHCOMPANY_VALIDATE';

function fetchPianoTechCompanyListSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechCompanyList = jsonResponse.pianoTechCompanyList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHCOMPANY_LIST_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FETCH_PIANOTECHCOMPANY_LIST_SUCCEEDED,
        pianoTechCompanyList
    }
}

function fetchPianoTechCompanyListFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechCompany list.';

    return {
        type: FETCH_PIANOTECHCOMPANY_LIST_FAILED,
        message: errorMessage
    }
}

export function fetchPianoTechCompanyList() {
    return dispatch => {

        dispatch({
            type: FETCH_PIANOTECHCOMPANY_LIST_STARTED
        });

        service
            .getPianoTechCompanyList()
            .then(resp => {
                dispatch(fetchPianoTechCompanyListSucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechCompanyListFailed(error))
            });
    }
}

function findPianoTechCompanySucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechCompany = jsonResponse.pianoTechCompany;
    const originalPianoTechCompany = Object.assign({}, pianoTechCompany);

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FIND_PIANOTECHCOMPANY_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FIND_PIANOTECHCOMPANY_SUCCEEDED,
        pianoTechCompany,
        originalPianoTechCompany,
    }
}

function findPianoTechCompanyFailed(response) {
    const errorMessage = 'Failed to find PianoTechCompany.';

    return {
        type: FIND_PIANOTECHCOMPANY_FAILED,
        message: errorMessage
    }
}

export function findPianoTechCompany(companyId) {
    return dispatch => {

        service
            .findPianoTechCompany(companyId)
            .then(resp => {
                dispatch(findPianoTechCompanySucceeded(resp))
            })
            .catch(error => {
                dispatch(findPianoTechCompanyFailed(error))
            });
    }
}

function savePianoTechCompanySucceeded(response, pianoTechCompany) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const message = 'PianoTechCompany ' + pianoTechCompany.maintenanceType + ' Successful.';
    let updatedPianoTechCompany = pianoTechCompany;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: SAVE_PIANOTECHCOMPANY_FAILED,
            message: errorMessage,
        }
    }

    if (jsonResponse.pianoTechCompany) {
        updatedPianoTechCompany = jsonResponse.pianoTechCompany;
    }

    return {
        type: SAVE_PIANOTECHCOMPANY_SUCCEEDED,
        pianoTechCompany: updatedPianoTechCompany,
        message,
    }
}

function savePianoTechCompanyFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: SAVE_PIANOTECHCOMPANY_FAILED,
        message: errorMessage
    }
}

export function savePianoTechCompany(pianoTechCompany) {
    return dispatch => {

        service
            .savePianoTechCompany(pianoTechCompany)
            .then(resp => {
                dispatch(savePianoTechCompanySucceeded(resp, pianoTechCompany))
            })
            .catch(error => {
                dispatch(savePianoTechCompanyFailed(error))
            });
    }
}

